import React from 'react';
import { SearchIcon, StarIcon } from 'lucide-react';
interface ModelsFilterPanelProps {
  modelSearch: string;
  setModelSearch: (search: string) => void;
  showOnlyModelFavorites: boolean;
  setShowOnlyModelFavorites: (show: boolean) => void;
  showOnlySelectedModels: boolean;
  setShowOnlySelectedModels: (show: boolean) => void;
}
export function ModelsFilterPanel({
  modelSearch,
  setModelSearch,
  showOnlyModelFavorites,
  setShowOnlyModelFavorites,
  showOnlySelectedModels,
  setShowOnlySelectedModels
}: ModelsFilterPanelProps) {
  return <div className="flex flex-col mb-4 gap-3" data-id="element-882">
      {/* Search input and Display Filter in the same row */}
      <div className="flex gap-3 items-center" data-id="element-883">
        {/* Search by name input */}
        <div className="relative flex-1" data-id="element-884">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-885">
            <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-886" />
          </div>
          <input type="text" value={modelSearch} onChange={e => setModelSearch(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2 dark:bg-darkbg-primary dark:border-darkbg-border dark:text-white" placeholder="Search by name..." data-id="element-887" />
        </div>
        {/* Display filter (ALL/Favorites) */}
        <div className="w-48" data-id="element-888">
          <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-889">
            Display Filter
          </p>
          <div className="flex border border-gray-300 rounded-lg overflow-hidden dark:border-darkbg-border w-full" data-id="element-890">
            <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${!showOnlyModelFavorites ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlyModelFavorites(false)} data-id="element-891">
              ALL
            </button>
            <button className={`flex-1 px-3 py-1.5 text-sm font-medium flex items-center justify-center ${showOnlyModelFavorites ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlyModelFavorites(true)} data-id="element-892">
              <StarIcon className="h-3 w-3 mr-1" data-id="element-893" />
              Favorites
            </button>
          </div>
        </div>
      </div>
      {/* Model scope filter on its own row */}
      <div data-id="element-894">
        <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1" data-id="element-895">
          Front Scope
        </p>
        <div className="flex border border-gray-300 rounded-lg overflow-hidden dark:border-darkbg-border w-full" data-id="element-896">
          <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${!showOnlySelectedModels ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlySelectedModels(false)} data-id="element-897">
            ALL
          </button>
          <button className={`flex-1 px-3 py-1.5 text-sm font-medium ${showOnlySelectedModels ? 'bg-blue-500 text-white dark:bg-accent-blue' : 'bg-gray-50 text-gray-700 dark:bg-darkbg-primary dark:text-gray-300'}`} onClick={() => setShowOnlySelectedModels(true)} data-id="element-898">
            Selected
          </button>
        </div>
      </div>
    </div>;
}